import axios from 'axios';
import config from '../environment/config';
import { authHeader } from './auth.header';
const API_URL = config.API_URL;

export const getActiveUserSubscriptionDetails = async () => {
  try {
    const response = await axios.get(`${API_URL}subscription-transactions/userSubscription-active`, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      console.warn('No active subscription found.');
      return null;
    }
  }
};

export class SubscriptionTransactionDto {
    constructor(subscriptionId,amount,paymentMode,paymentStatus,razorpayPaymentId) {
        this.subscriptionId = subscriptionId;
        this.amount = amount;
        this.paymentMode = paymentMode;
        this.paymentStatus = paymentStatus;
        this.razorpayPaymentId = razorpayPaymentId;
      }
  }


  export const getPaymentStatus = async (razorpayPaymentId) => {
    try {
        const response = await axios.get(
            `${API_URL}subscriptions/payment-status/${razorpayPaymentId}`, 
            { headers: authHeader() } 
        );

        return response.data || null;
    } catch (error) {
        console.error('Error occurred in getPaymentStatus', error);
        return null;
    }
};


  export const submitTransactionAdd = async (subscriptionTransactionDto) => {
    try {
        const response = await axios.post(
            `${API_URL}subscription-transactions/create`, 
            subscriptionTransactionDto,
            { headers: authHeader() }
          );
          if(response){
            return { success: true, message: "Your membership number "+ response.data.membershipNo +" is activated, Welcome to SMART Forum !" };
          }
    } catch (error) {
         console.error('Error occurred in submitTransactionAdd', error);
         return { success: false, message: error.response?.data };
    }
};



export const getMemberShipList = async () => {
    try {
      const response = await axios.get(`${API_URL}subscriptions/getMembershipTypeList`, {
        headers: authHeader(),
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.warn('Error occurred in getmemberShipTypeList', error);
        return null; 
      }
      throw error;
    }
  };


export const getPaymentDetails = async () => {
    try {
      const response = await axios.get(`${API_URL}subscription-transactions/payment-details`, {
        headers: authHeader(),
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.warn('Error occurred in getmemberShipTypeList', error);
        return null; 
      }
      throw error;
    }
  };
  
  

